function Scroller(elem, par) {
	
	this.bx = 0;
	this.by = 0;
	
	this.inX = 0;
	this.inY = 0;
	
	this.ldist = 0;
	this.cdist = 0;
	this.dist = 0;
	
	this.cy = 0;
	this.cx = 0;
	
	this.element = elem;
	this.scrollpane = par;
	
	this.scrolling = false;
	
	this.init = function() {
		this.bx = 0;
		this.by = 0;
		this.recalcBounds = true;
		this.scnt = 0;
		
		$(elem).on(Events.pointer.down, $.proxy(this.start, this));
		$(elem).on(Events.pointer.up, $.proxy(this.end, this));
		$(elem).on(Events.pointer.move, $.proxy(this.move, this));
		
		this.node3D = new css3DNode(this.element);
				
		this.calculateBounds();
				
		player.addProcess(this);
	}
	
	this.start = function(event) {
		var x;
		var y;

		var t = Events.getPointerEvent(event); //event.originalEvent.touches;
		
		
		if (t.points.length  > 1) {
			x = t.points[0].pageX - t.points[0].pageY;
			y = t.points[1].pageX - t.points[1].pageY;
			
			this.cdist = Math.sqrt(x * x, y * y);
		}
		
		//document.title = "start";
		
		this.bx = t.pageX;
		this.by = t.pageY;
		
		this.scrolling = true;
		
		event.preventDefault();
	};

	this.move = function(event) {
		var x;
		var y;
		
		if (!this.scrolling) return;
//		var t = event.originalEvent.touches;
		var t = Events.getPointerEvent(event); //event.originalEvent.touches;
				
		if (t.points.length > 1) {
			//x = t[0].pageX - t[1].pageX;
			//y = t[0].pageY - t[1].pageY;
			
			this.ldist = this.cdist;
			this.cdist = Math.sqrt(x * x + y * y);
			
			this.dist = (this.cdist - this.ldist);
		} else {		
			x = t.pageX;
			y = t.pageY;
			
			//$("#menubar").html(y - this.by);

			//$("#menubar").html(t.pageY + " : " + this.by);

			this.inX = (x - this.bx);
			this.inY = (y - this.by);
			
			if (this.inX > 30) this.inX = 30;
			if (this.inX < -30) this.inX = -30;
			
			if (this.inY > 30) this.inY = 30;
			if (this.inY < -30) this.inY = -30;
						
			this.bx = x;
			this.by = y;
		}
		
		event.preventDefault();
		event.stopPropagation();
	};

	this.end = function(event) {
		//this.move(event);
		this.scrolling = false;
		//document.title = "stop";
		
		//event.preventDefault();
		//event.stopPropagation();
		return false;
	};
	
	this.distance = function() {
		var r = this.dist;
		
		this.dist *= 0.5;
		
		return r;
	};
	
	this.inertiaX = function() {		
		var ret = this.inX;
		this.inX *= 0.95;
		if (!isNaN(ret)) return ret;
		else return 0;
	};
	
	this.inertiaY = function() {
		var ret = this.inY;
		this.inY *= 0.95;
		if (!isNaN(ret)) return ret;
		else return 0;
	};

	
	this.isScrolling = function() {
		if (Math.abs(this.inX) > 0.4 || Math.abs(this.inY) > 0.4) return true;
		return false;
	};
	
	this.jumpTo = function(px,py) {
		this.cy = py;
		this.cx = px;
	},
	
	this.calculateBounds = function() {
		this.recalcBounds = true;
		scnt = 0;
	},
	
	this.calculateBoundsLazy = function() {
		this.scrollpane_height = $(this.scrollpane).height();
		this.scrollpane_width = $(this.scrollpane).width();
		this.outerHeight = $(this.element).outerHeight(true);
		this.outerWidth = $(this.element).outerWidth(true);
	},
	
	this.process = function() {
			if (this.recalcBounds || this.scnt > 150) {
				this.calculateBoundsLazy();
				this.recalcBounds = false;
				this.scnt = 0;
			} else {
				this.scnt ++;
			}
		
			//this.calculateBounds();
			
			if (isNaN(this.cy)) this.cy = 0;

			var yy = this.inertiaY();
			this.cy += yy;
			this.cx += this.inertiaX();
			
			//$("#menubar").html(this.scnt + " : " + this.cy + " : " + yy);

			//$("#menubar").html(yy);
			
			if (this.cy > 0) this.cy = 0;
	//		if (this.cy < $(this.scrollpane).height() - $(this.element).outerHeight(true)) this.cy = $(this.scrollpane).height() - $(this.element).outerHeight(true);
//			if (this.cy < this.scrollpane_height - this.outerHeight) this.cy = this.scrollpane_height - this.outerHeight;
			//var diff = this.scrollpane_height - this.outerHeight;

			var diff = this.scrollpane_height - this.outerHeight;
			if (diff > 0) diff = 0;
			
			if (this.cy < diff) this.cy =  diff;
			if (this.cx > 0) this.cx = 0;
	//		if (this.cx < $(this.scrollpane).width() - $(this.element).outerWidth(true)) this.cx = $(this.scrollpane).width() - $(this.element).outerWidth(true);
			if (this.cx < this.scrollpane_width - this.outerWidth) this.cx = this.scrollpane_width - this.outerWidth;
			
	//		document.title = "move : " + Math.round(this.inY) + " ; " + Math.round(this.cy);
							
			
			this.node3D.resetTransform();
//			this.node3D.translate(this.cx,Math.round(this.cy),0);
			this.node3D.translate(this.cx, this.cy,0);
			this.node3D.applyTransforms();
	}
	
	this.init();
}